import { RpcNotification } from './rpc-notification-model';

/**
 * Rpc notification sever side handler interface.
 */
export interface RpcNotificationHandler {
    handler(data: RpcNotification): Promise<void>;
}
